'use strict';

/**
 * Page-level opt-out for post-select redirect/reload.
 * Missing attribute keeps historical refresh behavior.
 *
 * @returns {boolean}
 */
function shouldRefreshAfterVehicleSelection() {
	const element = document.querySelector('[data-should-refresh-after-vehicle-selection]');
	if (!element) {
		return true;
	}

	const value = element.dataset.shouldRefreshAfterVehicleSelection;
	return value !== 'false' && value !== '0';
}

module.exports = {
	shouldRefreshAfterVehicleSelection,
};
